import { defineStore } from "pinia";

// IMPORTANT: 'currentLanguage' is defined in the DOM, find it in the assets.php file.

export const useTranslationStore = defineStore("translation", {
    state: () => ({
        has_initialized_dictionary: false,
        language: "en", // English is the default.
        translations: {
            it: null,
            de: null,
            nl: null,
            da: null,
            sv: null,
            fr: null,
        },
    }),

    getters: {
        dictionary() {
            return this.translations[this.language];
        },
    },

    actions: {
        translate(string, variables) {
            let translatedString = this.translatedString(string); // This can still contain variables

            return this.replaceVariables(translatedString, variables);
        },

        translatedString(string) {
            this.initializeDictionary();

            if (this.language == "en") return string;

            // French does not exist yet.
            // if (this.language == "fr") return string;

            if (!this.dictionary || !this.dictionary[string]) return string;

            return this.dictionary[string];
        },

        replaceVariables(translatedString, variables) {
            if (!variables) return translatedString;
            return translatedString.replace(/:(\w+)/g, (_, key) =>
                key in variables ? variables[key] : `:${key}`,
            );
        },

        initializeDictionary() {
            if (!this.has_initialized_dictionary) {
                this.language =
                    typeof currentLanguage !== "undefined"
                        ? currentLanguage
                        : "en";
                // let translationFile = "./translations/it.json"; // Ex: "./translations/dk.json"
                this.translations.it = require("./translations/it.json");
                this.translations.da = require("./translations/da.json");
                this.translations.de = require("./translations/de.json");
                this.translations.nl = require("./translations/nl.json");
                this.translations.sv = require("./translations/sv.json");
                this.translations.fr = require("./translations/fr.json");
            }

            this.has_initialized_dictionary = true;
        },

        countriesList() {
            if (this.language == "en")
                return require("./countries/countries_en.json");
            if (this.language == "da")
                return require("./countries/countries_da.json");
            if (this.language == "it")
                return require("./countries/countries_it.json");
            if (this.language == "nl")
                return require("./countries/countries_nl.json");
            if (this.language == "fr")
                return require("./countries/countries_fr.json");
            if (this.language == "sv")
                return require("./countries/countries_sv.json");

            return [];
        },
    },
});
